import React from 'react';
import styled from 'styled-components';
// import warningIcon from '@ikea-ux/ssr-icon/paths/message-warning-bg-24';
// import SSRIcon from '@ikea-ux/ssr-icon';

import SSRIcon from "@ingka/ssr-icon";
import '@ingka/svg-icon/dist/style.css';
import warningIcon from '@ingka/ssr-icon/paths/warning-triangle';
import TextTranslatable from '../Internationalization/TextTranslatable';

// Chrome
export const isChrome =
  !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

// Edge
export const isEdgeChromium = navigator.userAgent.indexOf('Edg') !== -1;

// IE
export const isIE = navigator.userAgent.indexOf('MSIE') !== -1;

const MessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 768px;
  margin: 1rem auto;
  padding: 0.75rem 1rem;
  border: 1px solid #959595;
  border-radius: 4px;
  color: #111;
`;

const IconContainer = styled.div`
  flex: 0 0;
  margin-right: 1rem;
`;

const TextContainer = styled.div`
  flex: 1 1 500;
`;

const Header = styled.h4`
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
`;

const Text = styled.p`
  margin: 0;
`;

const UnsupportedBrowserMessage = () => {
  const isUsingSupportedBrowser = !isIE;
  if (isUsingSupportedBrowser) {
    return null;
  }

  return (
    <MessageContainer>
      <IconContainer>
        <SSRIcon size="150" paths={warningIcon} />
      </IconContainer>
      <TextContainer>
        <Header>
          <TextTranslatable textId="unsupported_browser_title" />
        </Header>
        <Text>
          <TextTranslatable textId="unsupported_browser_message" />
        </Text>
      </TextContainer>
    </MessageContainer>
  );
};

export default UnsupportedBrowserMessage;
